/**
 * Heuristic detection of "I can't answer this" inline responses, so the
 * review panel can offer an Ask-in-chat hand-off instead of an Accept button
 * that would paste the refusal into the note.
 *
 * Patterns prefer documentation-meta / refusal verbs (answer, find,
 * determine, …) over bare first-person modals, so short clinical lines like
 * "I cannot sleep at night" are less likely to match. Only short responses
 * are considered — longer edits are never flagged via the length cap.
 */
const REFUSAL_PATTERNS: RegExp[] = [
  /not available in the (provided|clinical|current)/i,
  /i can help with questions about/i,
  /\bi (cannot|can't|am unable to) (answer|find|determine|provide|locate)\b/i,
  /\bi'?m unable to (answer|find|determine|provide|locate)\b/i,
  /\b(i|heidi)('?m| am|'?s| is) unable to (answer|find|determine|provide|locate)\b/i,
  /couldn'?t find( any)? (relevant )?(information|details|mention)/i,
  /don'?t have (access|enough (information|context))/i,
  /\b(this|that|it) is not mentioned in (the|this|your)/i,
];

const MAX_REFUSAL_LENGTH = 500;

export const isUnansweredInlineResponse = (text: string): boolean => {
  const trimmed = text.trim();
  if (!trimmed || trimmed.length > MAX_REFUSAL_LENGTH) return false;
  return REFUSAL_PATTERNS.some((pattern) => pattern.test(trimmed));
};
